export const SELECTION_KEY = 'dataset-entitlements';

export const SECTION_NAME = 'Dataset Entitlements';

export const NO_ASSIGNED_ENTITLEMENT_TITLE =
    'There are currently no Dataset resources assigned.';

export const NO_ASSIGNED_ENTITLEMENT_DESCRIPTION =
    'Please reach out to the PB Admin team to request an entitlement update.';
